module.exports = {
        srcSet: "/_next/static/images/html5-player-640.47ed9471.webp"+" 640w"+","+"/_next/static/images/html5-player-828.a86f2725.webp"+" 828w"+","+"/_next/static/images/html5-player-1030.85a0c7fc.webp"+" 1030w",
        images: [{path: "/_next/static/images/html5-player-640.47ed9471.webp",width: 640,height: 496},{path: "/_next/static/images/html5-player-828.a86f2725.webp",width: 828,height: 641},{path: "/_next/static/images/html5-player-1030.85a0c7fc.webp",width: 1030,height: 798}],
        src: "/_next/static/images/html5-player-1030.85a0c7fc.webp",
        toString: function(){return "/_next/static/images/html5-player-1030.85a0c7fc.webp"},
        
        width: 1030,
        height: 798
      }